import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { API_BASE_URL, API_ENVIRONMENT } from "./lib/api";

// Which backend this bundle was built against is baked in and invisible from
// the UI, so say it out loud — a tester handed a URL can check the console
// instead of guessing whether they are on the staging build.
if (API_ENVIRONMENT !== "production") {
  console.info(`Naurist admin: ${API_ENVIRONMENT} API (${API_BASE_URL})`);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
